var autoAdjustOverflow = {
  adjustX: true,
  adjustY: true
};
var disableAdjustOverflow = {
  adjustX: false,
  adjustY: false
}; // https://github.com/react-component/trigger/blob/ec9ad5a27507eee1bd2dc5645550db1adba1456a/src/interface.ts#L46

export var getPlacements = function getPlacements(isOverflow) {
  var overflow = isOverflow ? autoAdjustOverflow : disableAdjustOverflow;
  return {
    left: {
      points: ['cr', 'cl'],
      overflow: overflow
    },
    right: {
      points: ['cl', 'cr'],
      overflow: overflow
    },
    top: {
      points: ['bc', 'tc'],
      overflow: overflow
    },
    bottom: {
      points: ['tc', 'bc'],
      overflow: overflow
    },
    topLeft: {
      points: ['bl', 'tl'],
      overflow: overflow
    },
    topRight: {
      points: ['br', 'tr'],
      overflow: overflow
    },
    bottomRight: {
      points: ['tr', 'br'],
      overflow: overflow
    },
    bottomLeft: {
      points: ['tl', 'bl'],
      overflow: overflow
    }
  };
};
var placements = getPlacements(false);
export default placements;